import React, { useEffect, useRef, forwardRef } from "react";
import { getDate, currentDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";

const InDsLoiNhuanBanHang = forwardRef(({ listData, totals }, ref) => {
    return (
        <div ref={ref} id="tblExcelLoiNhuan" style={{
            padding: "30px",
            width: "100%",
        }}>
            <table
                border="1"
                className="table-bordered"
                style={{
                    borderCollapse: "collapse",
                    width: "100%",
                    fontFamily: "Arial",
                    fontSize: "17px",
                    color: "#000",
                }}
            >
                <thead>
                    <tr>
                        <th colSpan="9" style={{
                            fontSize: "18px",
                            border: "1px solid #000",
                            textAlign: "center",
                            padding: "8px 0",
                        }}>
                            LỢI NHUẬN BÁN HÀNG
                        </th>
                    </tr>
                    <tr>
                        <th colSpan="9" style={{ textAlign: "center", border: "1px solid #000", padding: "5px" }}>
                            Ngày in: {currentDate()}
                        </th>
                    </tr>
                    <tr style={{ backgroundColor: "#f2f2f2", fontWeight: "bold" }}>
                        <th>STT</th>
                        <th>Ngày</th>
                        <th>Mã đơn hàng</th>
                        <th>Tên tài sản</th>
                        <th>Khách hàng</th>
                        <th style={{ textAlign: "right" }}>Số tiền mua</th>
                        <th style={{ textAlign: "right" }}>Phí sản xuất</th>
                        <th style={{ textAlign: "right" }}>Số tiền bán</th>
                        <th style={{ textAlign: "right" }}>Lợi nhuận</th>
                    </tr>
                </thead>
                <tbody>
                    {listData?.map((item, idx) => {
                        return (
                            <tr key={`${item.OrderID}-${item.TaiSanID}` || idx}>
                                <td style={{ textAlign: "center" }}>{item.STT}</td>
                                <td>{getDate(item.CreatedDate)}</td>
                                <td>{item.OrderCode}</td>
                                <td>{item.TenTaiSan}</td>
                                <td>{item.CustomerName}</td>
                                <td style={{ textAlign: "right" }}>{formatNumber(item.GiaMua)}</td>
                                <td style={{ textAlign: "right" }}>{formatNumber(item.PhiSanXuat)}</td>
                                <td style={{ textAlign: "right" }}>{formatNumber(item.GiaBan)}</td>
                                <td style={{ textAlign: "right" }}>{formatNumber(item.LoiNhuan)}</td>
                            </tr>
                        )
                    })}
                </tbody>
                <tfoot>
                    <tr style={{ fontWeight: "bold" }}>
                        <td colSpan="5" style={{ textAlign: "center" }}>Tổng</td>
                        <td style={{ textAlign: "right" }}>{formatNumber(totals.TotalSoTienMua)}</td>
                        <td style={{ textAlign: "right" }}>{formatNumber(totals.TotalPhiSanXuat)}</td>
                        <td style={{ textAlign: "right" }}>{formatNumber(totals.TotalSoTienBan)}</td>
                        <td style={{ textAlign: "right" }}>{formatNumber(totals.TotalLoiNhuan)}</td>
                    </tr>
                </tfoot>
            </table>
            <style>
                {`
                    @media print {
                        body > * { display: none !important; }
                        #tblExcelLoiNhuan { 
                            display: block !important; 
                            position: absolute; top: 0; left: 0; width: 100%;
                        }
                    }
                    .table-bordered th, .table-bordered td {
                        border: 1px solid #000; padding: 5px; vertical-align: top;
                    }
                    .table-bordered th { background-color: #f2f2f2; }
                    .table-bordered { border: 1px solid #000; }
                    @page { size: A4 portrait; margin: 20mm 10mm; }
                    @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
                `}
            </style>
        </div>
    );
});

export default InDsLoiNhuanBanHang;